export const statusOptions = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  closed: 'CLOSED',
}

export const getNextStatusValue = (status: string, type: 'status'|'color'|'label'|'text' ) => {
  if(type === 'status') {
    if(status === statusOptions.active) return statusOptions.closed
    if(status === statusOptions.inactive) return statusOptions.active
    if(status === statusOptions.closed) return statusOptions.inactive
  }
  if(type === 'color') {
    if(status === statusOptions.active) return '#dd5600'
    if(status === statusOptions.inactive) return '#669533'
    if(status === statusOptions.closed) return '#bd4247'
  }
  if(type === 'label') {
    if(status === statusOptions.active) return 'Close'
    if(status === statusOptions.inactive) return 'Activate'
    if(status === statusOptions.closed) return 'Deactivate'
  }
  if(type === 'text') {
    if(status === statusOptions.active) return 'closed'
    if(status === statusOptions.inactive) return 'activated'
    if(status === statusOptions.closed) return 'deactivated'
  }
  
  return status
}
export const getNextServerStatusValue = (status: string, type: 'status'|'color'|'label'|'text' ) => {
  if(type === 'status') {
    if(status === statusOptions.active) return statusOptions.inactive
    if(status === statusOptions.inactive) return statusOptions.active
  }
  if(type === 'color') {
    if(status === statusOptions.active) return '#bd4247'
    if(status === statusOptions.inactive) return '#669533'
  }
  if(type === 'label') {
    if(status === statusOptions.active) return 'Deactivate'
    if(status === statusOptions.inactive) return 'Activate'
  }
  if(type === 'text') {
    if(status === statusOptions.active) return 'deactivated'
    if(status === statusOptions.inactive) return 'activated'
  }
  
  return status
}

